var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkillLanguages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.96108 22.5C8.72187 22.5 8.48267 22.4087 8.30078 22.225C7.93574 21.8587 7.93574 21.265 8.30078 20.8987L11.6882 17.5L8.29953 14.1C7.9345 13.7337 7.9345 13.14 8.29953 12.7737C8.66456 12.4075 9.25634 12.4075 9.62138 12.7737L13.6704 16.8362C14.0354 17.2025 14.0354 17.7962 13.6704 18.1625L9.62138 22.225C9.43948 22.4087 9.20028 22.5 8.96108 22.5Z",
    fill: "#7040c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0424 22.5H16.4361C15.9203 22.5 15.5017 22.08 15.5017 21.5625C15.5017 21.045 15.9203 20.625 16.4361 20.625H22.0424C22.5582 20.625 22.9768 21.045 22.9768 21.5625C22.9768 22.08 22.5582 22.5 22.0424 22.5Z",
    fill: "#7040c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0258 28.7501H3.97759C2.08764 28.7501 0.551514 27.2089 0.551514 25.3126V4.68762C0.551514 2.79137 2.08764 1.25012 3.97759 1.25012H27.0258C28.9157 1.25012 30.4518 2.79137 30.4518 4.68762V25.3126C30.4518 27.2089 28.9157 28.7501 27.0258 28.7501ZM3.97759 3.12512C3.1192 3.12512 2.42028 3.82637 2.42028 4.68762V25.3126C2.42028 26.1739 3.1192 26.8751 3.97759 26.8751H27.0258C27.8842 26.8751 28.5831 26.1739 28.5831 25.3126V4.68762C28.5831 3.82637 27.8842 3.12512 27.0258 3.12512H3.97759Z",
    fill: "#7040c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5175 7.5H1.4859C0.970118 7.5 0.551514 7.08 0.551514 6.5625C0.551514 6.045 0.970118 5.625 1.4859 5.625H29.5175C30.0332 5.625 30.4518 6.045 30.4518 6.5625C30.4518 7.08 30.0332 7.5 29.5175 7.5Z",
    fill: "#7040c2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.9003,
    height: 30,
    fill: "white",
    transform: "translate(0.551514)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillLanguages);
export default __webpack_public_path__ + "static/media/skill-languages.66704b814957b599f09d22c6ef906e5a.svg";
export { ForwardRef as ReactComponent };